var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("\n\t\t\t雇主险出险-" + _vm._s(_vm.ruleForm.id === null || _vm.ruleForm.id === '' ? '新增' : '修改'))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "540px",
      "background-color": "white",
      "margin": "75px 40px 0 40px",
      "padding": "100px",
      "overflow-x": "hidden"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#006E4B",
      "font-weight": "900",
      "font-size": "20px"
    }
  }, [_vm._v("| ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700"
    }
  }, [_vm._v("人员信息")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #DADADA",
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "180px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    on: {
      "click": _vm.StaffFind
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "40px",
      "width": "80%"
    },
    attrs: {
      "label": "姓名",
      "prop": "staff_id"
    }
  }, [_c('el-input', {
    attrs: {
      "onfocus": "this.blur();"
    },
    model: {
      value: (_vm.ruleForm.staff_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "staff_name", $$v)
      },
      expression: "ruleForm.staff_name"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "40px",
      "width": "80%"
    },
    attrs: {
      "label": "身份证号",
      "prop": "staff_card"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.staff_card),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "staff_card", $$v)
      },
      expression: "ruleForm.staff_card"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "手机号",
      "prop": "staff_telephone"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.staff_telephone),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "staff_telephone", $$v)
      },
      expression: "ruleForm.staff_telephone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "性别",
      "prop": "staff_gender"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.staff_gender),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "staff_gender", $$v)
      },
      expression: "ruleForm.staff_gender"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "年龄",
      "prop": "staff_age"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.staff_age),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "staff_age", $$v)
      },
      expression: "ruleForm.staff_age"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "岗位",
      "prop": "post_name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.post_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "post_name", $$v)
      },
      expression: "ruleForm.post_name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "城市",
      "prop": "city_id"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.city_id),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "city_id", $$v)
      },
      expression: "ruleForm.city_id"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "组织架构"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.ruleForm.range),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "range", $$v)
      },
      expression: "ruleForm.range"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row'), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#006E4B",
      "font-weight": "900",
      "font-size": "20px"
    }
  }, [_vm._v("| ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700"
    }
  }, [_vm._v("出险信息")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #DADADA",
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "label": "出险时间",
      "prop": "danger_dete"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "73%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "请选择出险时间"
    },
    model: {
      value: (_vm.ruleForm.danger_dete),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "danger_dete", $$v)
      },
      expression: "ruleForm.danger_dete"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    staticStyle: {
      "width": "85%"
    },
    attrs: {
      "label": "出险经过",
      "prop": "danger_after"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2
    },
    model: {
      value: (_vm.ruleForm.danger_after),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "danger_after", $$v)
      },
      expression: "ruleForm.danger_after"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "事故照片",
      "prop": "accident_photo"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.$globals.http + '/file/upload',
      "list-type": "picture-card",
      "on-preview": _vm.sghandlePictureCardPreview,
      "limit": 4,
      "on-remove": _vm.handleRemove,
      "file-list": _vm.ruleForm.accident_photo,
      "on-success": _vm.sghandleAvatarSuccess
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.ruleForm.accident_photo,
      "alt": ""
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "报案号",
      "prop": "report_no"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入报案号"
    },
    model: {
      value: (_vm.ruleForm.report_no),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "report_no", $$v)
      },
      expression: "ruleForm.report_no"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "保单号",
      "prop": "policy_no"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "73%"
    },
    attrs: {
      "placeholder": "请选择保单号",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.policy_no),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "policy_no", $$v)
      },
      expression: "ruleForm.policy_no"
    }
  }, _vm._l((_vm.Employer), function(item) {
    return _c('el-option', {
      key: item.policy_no,
      attrs: {
        "label": item.policy_no,
        "value": item.policy_no
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "理赔情况",
      "prop": "settlement_status"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "73%"
    },
    attrs: {
      "placeholder": "请选择理赔情况",
      "clearable": ""
    },
    on: {
      "change": _vm.saveRules
    },
    model: {
      value: (_vm.ruleForm.settlement_status),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "settlement_status", $$v)
      },
      expression: "ruleForm.settlement_status"
    }
  }, _vm._l((_vm.ztList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "医疗票据",
      "prop": "bill_url"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.$globals.http + '/file/upload',
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "limit": 1,
      "on-remove": _vm.handleRemove,
      "file-list": _vm.ruleForm.bill_url,
      "on-success": _vm.handleAvatarSuccess
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.ruleForm.bill_url,
      "alt": ""
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "收保险公司理赔款",
      "prop": "settlement_amount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "请输入收保险公司理赔款"
    },
    model: {
      value: (_vm.ruleForm.settlement_amount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "settlement_amount", $$v)
      },
      expression: "ruleForm.settlement_amount"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "付员工理赔款",
      "prop": "indemnity_amount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "请输入付员工理赔款"
    },
    model: {
      value: (_vm.ruleForm.indemnity_amount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "indemnity_amount", $$v)
      },
      expression: "ruleForm.indemnity_amount"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "结案日期",
      "prop": "close_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "73%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "请选择结案日期"
    },
    model: {
      value: (_vm.ruleForm.close_date),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "close_date", $$v)
      },
      expression: "ruleForm.close_date"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "情况备注",
      "prop": "remarks"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写备注"
    },
    model: {
      value: (_vm.ruleForm.remarks),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "remarks", $$v)
      },
      expression: "ruleForm.remarks"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "400px",
      "margin-top": "50px"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id === null || _vm.ruleForm.id === ''),
      expression: "ruleForm.id === null || ruleForm.id === ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id != null && _vm.ruleForm.id != ''),
      expression: "ruleForm.id != null && ruleForm.id != ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.Update('ruleForm')
      }
    }
  }, [_vm._v("修改")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择姓名",
      "visible": _vm.dialogVisibles,
      "width": "40%",
      "center": true,
      "close-on-click-modal": true,
      "show-close": false,
      "modal-append-to-body": false,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibles = $event
      }
    }
  }, [_c('el-row', [_c('organizeStaff', {
    ref: "organizeStaff",
    attrs: {
      "type": "radio",
      "accordion": false,
      "staff_id_prop": _vm.ruleForm.staff_id
    },
    on: {
      "commit": _vm.saveChange
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.$refs['organizeStaff'].commit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-011fb2c0","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bxgl/GzxCx/Gzxcx_add.vue
// module id = null
// module chunks = 